// @flow weak

import React            from 'react';
import PropTypes        from 'prop-types';
import cx               from 'classnames';
import { Link }         from 'react-router-dom';
import FontIcon         from 'material-ui/FontIcon';
import IconButton       from 'material-ui/IconButton';
import yellowA700       from 'material-ui/styles/colors';
import device           from "current-device";

const styles = {
  mediumIcon: {
    width: 48,
    color: '#FFFF'
  },
  medium: {
    width: 96,
    padding: 2,
  },
  smallIcon: {
    width: 30,
    color: '#FFFF'
  },
  small: {
    width: 40,
    padding: 2,
  },
};

const ViewLink = ({
  isActive,
  linkTo,
  viewName,
  itemCount,
  faIconName,
  label,
  mediumIconStyle,
  smallIconStyle
}) => (
  <IconButton fontSize= {40} tooltip={viewName} containerElement={<Link to={linkTo} />} iconStyle={device.mobile()?smallIconStyle:mediumIconStyle}
      style={device.mobile()? styles.small : styles.medium}>
    <FontIcon className={device.mobile() ? `fa ${faIconName} fa-xs` : `fa ${faIconName} fa-lg`} hoverColor={yellowA700} aria-label={label}>
    
    </FontIcon>
  </IconButton>
);

ViewLink.propTypes = {
  isActive:   PropTypes.bool,
  viewName:   PropTypes.string.isRequired,
  linkTo:     PropTypes.string.isRequired,
  faIconName: PropTypes.string.isRequired,
  itemCount:  PropTypes.number,
  label:      PropTypes.string.isRequired
};

ViewLink.defaultProps = {
  isActive: false
};

export default ViewLink;



// WEBPACK FOOTER //
// ./src/app/components/aside/asideLeft/menu/menuLinks/viewLink/ViewLink.js